export default function AttendanceSummaryTable({ summary, totalTrainings }) {
  // compute totals for footer row
  const totals = {
    present: summary.reduce((sum, p) => sum + p.present, 0),
    late: summary.reduce((sum, p) => sum + p.late, 0),
    absent: summary.reduce((sum, p) => sum + p.absent, 0),
    mc: summary.reduce((sum, p) => sum + p.mc, 0),
    tournament: summary.reduce((sum, p) => sum + p.tournament, 0),
    emergency: summary.reduce((sum, p) => sum + p.emergency, 0),
    event: summary.reduce((sum, p) => sum + p.event, 0),
    totalAttendance: summary.reduce((sum, p) => sum + p.total, 0),
    overallPercent:
      totalTrainings > 0 && summary.length > 0
        ? (
            (summary.reduce((sum, p) => sum + p.total, 0) /
              (totalTrainings * summary.length)) *
            100
          ).toFixed(1)
        : "0.0",
  };

  return (
    <div className="overflow-x-auto px-6">
      <table className="w-full text-sm border min-w-[900px]">
        <thead className="bg-gray-100">
          <tr>
            <th className="px-2 py-1 border text-left">Player</th>
            <th className="px-2 py-1 border">Present</th>
            <th className="px-2 py-1 border">Late</th>
            <th className="px-2 py-1 border">Absent</th>
            <th className="px-2 py-1 border">MC</th>
            <th className="px-2 py-1 border">Tournament</th>
            <th className="px-2 py-1 border">Emergency</th>
            <th className="px-2 py-1 border">Event</th>
            <th className="px-2 py-1 border">Total Attendance</th>
            <th className="px-2 py-1 border">Attendance %</th>
          </tr>
        </thead>
        <tbody>
          {summary.map((p, idx) => (
            <tr key={idx} className="text-center">
              <td className="px-2 py-1 border text-left">{p.name}</td>
              <td className="px-2 py-1 border">{p.present}</td>
              <td className="px-2 py-1 border">{p.late}</td>
              <td className="px-2 py-1 border">{p.absent}</td>
              <td className="px-2 py-1 border">{p.mc}</td>
              <td className="px-2 py-1 border">{p.tournament}</td>
              <td className="px-2 py-1 border">{p.emergency}</td>
              <td className="px-2 py-1 border">{p.event}</td>
              <td className="px-2 py-1 border font-semibold">
                {p.total}/{totalTrainings}
              </td>
              <td
                className={`px-2 py-1 border font-semibold ${
                  p.percent >= 80
                    ? "text-green-600"
                    : p.percent >= 50
                    ? "text-orange-500"
                    : "text-red-600"
                }`}
              >
                {p.percent}%
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot className="bg-gray-50 font-bold">
          <tr className="text-center">
            <td className="px-2 py-1 border text-left">TOTAL</td>
            <td className="px-2 py-1 border">{totals.present}</td>
            <td className="px-2 py-1 border">{totals.late}</td>
            <td className="px-2 py-1 border">{totals.absent}</td>
            <td className="px-2 py-1 border">{totals.mc}</td>
            <td className="px-2 py-1 border">{totals.tournament}</td>
            <td className="px-2 py-1 border">{totals.emergency}</td>
            <td className="px-2 py-1 border">{totals.event}</td>
            <td className="px-2 py-1 border font-semibold">
              {totals.totalAttendance}/{totalTrainings * summary.length}
            </td>
            <td className="px-2 py-1 border font-semibold">{totals.overallPercent}%</td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}
